import { DataService } from './dataService'

const CourierCountryServices = {
	addCouriercountryApi: async (data) => {
		return DataService.post('/admin/add_courier_country_services', data)
	},
	updateCouriercountryApi: async (data) => {
		return DataService.post('/admin/update_courier_country_services', data)
	},
	getCouriercountryApi: async (data) => {
		return DataService.get('/admin/get_courier_country_services', data)
	},
	getCourierZoneApi: async (data) => {
		return DataService.get('/admin/get_courier_country_services_zone', data)
	},
	importCouriercountryservice: async (data) => {
		return DataService.post('/admin/import_courier_country_services_price', data)
	},
	exportCouriercountryservice: async (data) => {
		return DataService.get('/admin/export_courier_country_services', data)
	},
	getCouriercountryserviceprices: async (data) => {
		return DataService.get('/admin/courier_country_services_prices', data)
	},
	deleteCourierCountryService: async (data) => {
		return DataService.delete('/admin/delete_courier_country_services' ,data)
	},

	
	
}

export default CourierCountryServices